// test1338
(1338 && 0);
